/*
 * Store data for the demo.
 *
 * Only the store information actually supplied for this iteration
 * is represented. Address, hours and exact contact data are intentionally
 * left out until the business provides them.
 */

export const stores = [
  {
    id: 'chabacano',
    name: 'Tienda Chabacano',
    alcaldia: 'CDMX',
    city: 'Ciudad de México',
    enabled: true,
  },
];

export function getStoreById(id) {
  return (
    stores.find(
      (store) =>
        store.id === id
    ) ?? null
  );
}
